
































































































































import Vue from 'vue';

import { Retailer } from '@/core/entity';
import CountryInput from '@/vue/components/input/Country.vue';

import { getRetailerQL } from './graphql';

export default Vue.extend({
  components: {
    'input-country': CountryInput,
  },

  props: {
    retailerId: String as () => string,
    loading: Boolean as () => boolean,
  },

  apollo: {
    retailer: {
      query: getRetailerQL,
      variables() {
        return { id: this.retailerId };
      },
      skip() {
        return !this.retailerId;
      },
      fetchPolicy: 'cache-and-network',
    },
  },

  data() {
    return {
      file: [] as File[],
      form: this.$form.createForm(this),
      logoUrl: '',
      retailer: null as Retailer | null,
    };
  },

  watch: {
    retailerId(newVal: string | null) {
      this.retailer = null;
    },
    retailer(newVal: Retailer) {
      if (newVal) {
        this.form.setFieldsValue({
          name: newVal ? newVal.name : '',
          country: newVal ? newVal.country : '',
          desId: newVal ? newVal.desId : '',
        });

        this.logoUrl = newVal ? newVal.logo!.url : '';
      }
    },
  },

  computed: {
    fileHelp(): string {
      const prevLogo =
        this.retailer && this.retailer.logo ? this.retailer.logo.id : null;

      const file = this.file.length > 0 ? this.file[0] : prevLogo;

      return file ? '' : 'Logo file is required.';
    },

    fileValidateStatus(): string {
      const prevLogo =
        this.retailer && this.retailer.logo ? this.retailer.logo.id : null;

      const file = this.file.length > 0 ? this.file[0] : prevLogo;

      return file ? 'success' : 'error';
    },
  },

  methods: {
    beforeUpload(file: File) {
      this.file = [file];
      return false;
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null) {
          const prevLogo =
            this.retailer && this.retailer.logo ? this.retailer.logo.id : null;

          const file = this.file.length > 0 ? this.file[0] : prevLogo;

          if (file === null) {
            return;
          }

          this.$emit('save', {
            name: val.name,
            country: val.country,
            desId: val.desId,
            file,
          });
        }
      });
    },
  },
});
